export default __webpack_public_path__ + "static/Hatton-Regular-92561324d74f42e3249400ad9e3c9616.woff2";